import api from './api';

async function fetchUsers() {
  return api.get('/user')
};

async function addUser(payload) {
  return api.post('/user', payload);
}

async function updateUser(id, payload) {
  return api.put(`/user/${id}`, payload);
}

async function deleteUser(id) {
  return api.delete(`/user/${id}`);
}

export { fetchUsers, addUser, updateUser, deleteUser };